export default "__VITE_ASSET__916e64d9__"